import { Sparkles } from "lucide-react";

export const SummerStageSouvenir = () => (
  <section className="py-20 md:py-24 relative overflow-hidden" data-testid="summer-stage-souvenir">
    <div className="absolute inset-0 bg-[#FFF3B0]/40 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 bg-white border-2 border-black rounded-full px-4 py-2 shadow-brutal-sm mb-6">
            <Sparkles size={14} />
            <span className="font-sans text-xs font-bold tracking-widest uppercase">
              Souvenir · Summer Stage 2026
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9]">
            Merci pour <br />
            <span className="italic">ces 3 jours</span> <br />
            d'énergie.
          </h2>
          <p className="mt-6 text-lg text-[#1a1a1a] leading-relaxed max-w-md">
            Le Summer Stage 2026 s'est terminé en beauté au Pays Basque. Petit·es et grand·es, débutant·es et confirmé·es — vous étiez extraordinaires. À très vite pour la prochaine édition.
          </p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 gap-4 md:gap-6">
          <div className="relative">
            <div className="absolute -inset-2 bg-[#FFD6C9] rounded-3xl -rotate-2" />
            <img
              src="/images/summer-stage-1.webp"
              alt="Souvenir Summer Stage — atelier parents-enfants"
              className="relative w-full aspect-[3/4] object-cover border-2 border-black rounded-3xl shadow-brutal"
              loading="lazy"
            />
          </div>
          <div className="relative mt-8 md:mt-12">
            <div className="absolute -inset-2 bg-[#C4F4E4] rounded-3xl rotate-2" />
            <img
              src="/images/summer-stage-2.webp"
              alt="Souvenir Summer Stage — atelier danse contemporaine"
              className="relative w-full aspect-[3/4] object-cover border-2 border-black rounded-3xl shadow-brutal"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
